import { AxiosPromise } from "axios";
import configs from "../configs";
import { SupportChatLiveApis } from "./live/supportChatLiveApis";

export interface SupportChatRequest {
  message: string;
  conversation_id?: string;
}

export interface SupportChatResponse {
  success: boolean;
  message: string;
  data: {
    reply: string;
    conversation_id?: string;
  };
}

export class SupportChatApis {
  private static supportChatLiveApis = new SupportChatLiveApis();

  static sendMessage(
    data: SupportChatRequest
  ): AxiosPromise<SupportChatResponse> {
    if (configs.type === "LOCAL") {
      return {} as AxiosPromise;
    }

    return this.supportChatLiveApis.sendMessage(data);
  }
}
